/******************************************************************************************
 *	File Reader Directive
 ******************************************************************************************/
(function() {
  

  angular.module('rcDirectives.rcFileReader', []).directive('rcFileReader', function() {
    return {
      scope: {
        fileReadContent: '=rcFileReader'
      },
      link: function(scope, element) {
        element.bind('change', function(changeEvent) {
          var reader = new FileReader();
          reader.onload = function(loadEvent) {
            scope.$apply(function() {
              scope.fileReadContent = loadEvent.target.result;
            });
          };
          reader.readAsText(changeEvent.target.files[0]);
        });
      }
    };
  });
})();
